<script setup lang="ts">
import { ChevronDown, Check } from 'lucide-vue-next';

defineProps<{
  isMarketPickerOpen: boolean;
}>();
</script>

<template>
  <div class="add-market-parity-mock dark">
    <div class="add-more-header dark">
      <h2 class="centered-title">Add another market</h2>
    </div>
    <div class="add-market-body dark">
      <div class="market-picker-card dark">
        <div class="market-picker-header" :class="{ open: isMarketPickerOpen }">
          Result <ChevronDown :size="18" />
          
          <!-- Market Category Dropdown -->
          <div v-if="isMarketPickerOpen" class="alter-market-dropdown-mock animate-in">
            <div class="dropdown-row active"><Check :size="16" /> Result</div>
            <div class="dropdown-row">Goals</div>
            <div class="dropdown-row">Corners</div>
            <div class="dropdown-row">Both Teams To Score</div>
            <div class="dropdown-row">Player To Score</div>
          </div>
        </div>
      </div>
    </div>
    <div class="add-more-footer dark"><button class="footer-btn-parity red">Add Market</button></div>
  </div>
</template>

<style scoped>
.add-market-parity-mock { height: 100%; min-height: 600px; background: #09090b; display: flex; flex-direction: column; }
.add-more-header { padding: 24px; border-bottom: 1px solid rgba(255,255,255,0.05); display: flex; align-items: center; justify-content: flex-start; position: relative; }
.centered-title { position: absolute; left: 50%; transform: translateX(-50%); font-size: 1.2rem; font-weight: 900; color: #fff; }

.add-market-body { padding: 40px; flex-grow: 1; display: flex; justify-content: center; }
.market-picker-card { background: #000; border: 1.5px solid #3f3f46; border-radius: 20px; width: 100%; max-width: 440px; padding: 20px; height: fit-content; color: #fff; position: relative; }
.market-picker-header { border: 1px solid #27272a; padding: 14px 20px; border-radius: 12px; display: flex; justify-content: space-between; align-items: center; font-weight: 800; margin-bottom: 12px; position: relative; cursor: pointer; transition: border-color 0.2s; }
.market-picker-header.open { border-color: #e21b0d; }

.alter-market-dropdown-mock { position: absolute; top: calc(100% + 8px); left: 0; right: 0; background: #111; border-radius: 10px; border: 1px solid #e21b0d; overflow: hidden; z-index: 100; box-shadow: 0 10px 30px rgba(0,0,0,0.5); }
.dropdown-row { padding: 12px 16px; font-size: 0.9rem; color: #a1a1aa; display: flex; align-items: center; gap: 10px; }
.dropdown-row.active { background: #18181b; color: #fff; font-weight: 700; }

.add-more-footer { padding: 32px; border-top: 1px solid rgba(255,255,255,0.05); display: flex; justify-content: center; }
.footer-btn-parity { width: 100%; max-width: 500px; height: 56px; border-radius: 16px; border: none; font-weight: 900; font-size: 1.1rem; cursor: pointer; background: #e21b0d; color: #fff; box-shadow: 0 8px 24px rgba(226, 27, 13, 0.3); }

@media (max-width: 768px) {
  .centered-title { position: static; transform: none; font-size: 1.5rem; margin-top: 8px; }
}

.animate-in { animation: fadeInUp 0.4s ease forwards; }
@keyframes fadeInUp { from { opacity: 0; transform: translateY(10px); } to { opacity: 1; transform: translateY(0); } }
</style>
